/*
 *
 * MeasurementCreate reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DESCENDANTS_WATCHER,
  GET_DESCENDANTS_SUCCESS,
  GET_DESCENDANTS_FAILED,
  POST_LOGO_EMAIL_WATCHER,
  POST_LOGO_EMAIL_SUCCESS,
  POST_LOGO_EMAIL_FAILED,
  POST_IMAGE_EMAIL_WATCHER,
  POST_IMAGE_EMAIL_SUCCESS,
  POST_IMAGE_EMAIL_FAILED,
  STEP_ONE_WATCHER,
  STEP_ONE_SUCCESS,
  STEP_ONE_FAILED,
  STEP_TWO_WATCHER,
  STEP_TWO_SUCCESS,
  STEP_TWO_FAILED,
  STEP_THIRD_WATCHER,
  STEP_THIRD_SUCCESS,
  STEP_THIRD_FAILED,
  STEP_FOURTH_WATCHER,
  STEP_FOURTH_SUCCESS,
  STEP_FOURTH_FAILED,
  GET_LEADERS_WATCHER,
  GET_LEADERS_SUCCESS,
  GET_LEADERS_FAILED,
  GET_SURVEYS_TYPE_WATCHER,
  GET_SURVEYS_TYPE_SUCCESS,
  GET_SURVEYS_TYPE_FAILED,
  GET_MEASURE_WATCHER,
  GET_MEASURE_SUCCESS,
  GET_MEASURE_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  GET_ORGANIZATION_SURVEYS_FAILED,
  GET_ORGANIZATION_SURVEYS_SUCCESS,
  GET_SEGMENTS_SURVEYS_WATCHER,
  GET_SEGMENTS_SURVEYS_FAILED,
  GET_SEGMENTS_SURVEYS_SUCCESS,
  UPDATE_MEASURE_WATCHER,
  UPDATE_MEASURE_SUCCESS,
  UPDATE_MEASURE_FAILED,
  STEP_MAIL_WATCHER,
  STEP_MAIL_SUCCESS,
  STEP_MAIL_FAILED,
  STEP_RECIPIENTS_WATCHER,
  STEP_RECIPIENTS_SUCCESS,
  STEP_RECIPIENTS_FAILED,
  STEP_DATACHECK_WATCHER,
  STEP_DATACHECK_SUCCESS,
  STEP_DATACHECK_FAILED,
  STEP_PREVIEW_WATCHER,
  STEP_PREVIEW_SUCCESS,
  STEP_PREVIEW_FAILED,
  STEP_SCHEDULE_WATCHER,
  STEP_SCHEDULE_SUCCESS,
  STEP_SCHEDULE_FAILED,
  STEP_COMPLETE_WATCHER,
  STEP_COMPLETE_SUCCESS,
  STEP_COMPLETE_FAILED,
  FORCE_SAVE_WATCHER,
  FORCE_SAVE_SUCCESS,
  FORCE_SAVE_FAILED,
  GET_EMPLOYEES_BY_SEGMENTS_FAILED,
  GET_EMPLOYEES_BY_SEGMENTS_SUCCESS,
  GET_EMPLOYEES_BY_SEGMENTS_WATCHER,
} from "./constants"

export const initialState = fromJS({
  divisions: {},
  isLoadingDivisions: false,
  descendents: [],
  isLoadingDescendents: false,
  isLoadingLogoUrl: false,
  isLoadingImageUrl: false,
  imageUrl: "",
  surveysType: [],
  isLoadingSurveysType: true,

  nameMeasurement: "",
  // step one
  firstStepData: {},
  isLoadingFirstStepData: false,
  // step two
  secondStepData: {},
  isLoadingSecondStepData: false,
  // step third
  thirdStepData: {},
  isLoadingThirdStepData: false,
  // step fourth
  fourthStepData: {},
  isLoadingFourthStepData: false,

  logoUrl: "",
  getLeaders: [],
  isLoadingGetLeaders: true,

  // newStepOne
  measure: {},
  isLoadingMeasure: false,
  segments: [],
  isLoadingSegments: false,
  surveyTypes: [],
  isLoadingSurveyTypes: false,
  scopeTypes: [],
  isLoadingScopeTypes: false,
  organizationSurveys: [],
  isLoadingOrganizationSurveys: false,
  segmentsSurveys: [],
  isLoadingSegmentsSurveys: false,
  isLoadingUpdateMeasure: false,

  // mailStep
  mailStepData: {},
  isLoadingMailStepData: false,

  // recipientsStep
  recipientsStepData: {},
  isLoadingRecipientsStepData: false,

  // datacheck step
  dataCheckStepData: [],
  isLoadingDataCheckStepData: false,

  // preview step
  previewStepData: {},
  isLoadingPreviewStepData: false,

  // schedule
  scheduleStepData: {},
  isLoadingScheduleStepData: false,

  // complete step
  completeStepData: {},
  isLoadingCompleteStepData: false,

  forceSaveData: {},
  isLoadingForceSaveData: false,

  recipientsSegments: [],
  isLoadingRecipientsSegments: false,
})

function measurementCreateReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SURVEYS_TYPE_WATCHER:
      return state.set("isLoadingSurveysType", true).set("surveysType", [])
    case GET_SURVEYS_TYPE_SUCCESS:
      return state
        .set("isLoadingSurveysType", false)
        .set("surveysType", action.payload)
    case GET_SURVEYS_TYPE_FAILED:
      return state.set("isLoadingSurveysType", false).set("surveysType", [])

    case GET_LEADERS_WATCHER:
      return state.set("getLeaders", []).set("isLoadingGetLeaders", true)
    case GET_LEADERS_SUCCESS:
      return state
        .set("getLeaders", action.payload)
        .set("isLoadingGetLeaders", false)
    case GET_LEADERS_FAILED:
      return state.set("getLeaders", []).set("isLoadingGetLeaders", false)

    case STEP_FOURTH_WATCHER:
      return (
        state
          // .set('fourthStepData', {})
          .set("isLoadingFourthStepData", true)
      )
    case STEP_FOURTH_SUCCESS:
      return state
        .set("fourthStepData", action.payload)
        .set("isLoadingFourthStepData", false)
    case STEP_FOURTH_FAILED:
      return state
        .set("fourthStepData", {})
        .set("isLoadingFourthStepData", false)

    case STEP_THIRD_WATCHER:
      return state.set("thirdStepData", {}).set("isLoadingThirdStepData", true)
    case STEP_THIRD_SUCCESS:
      return state
        .set("thirdStepData", action.payload)
        .set("isLoadingThirdStepData", false)
    case STEP_THIRD_FAILED:
      return state.set("thirdStepData", {}).set("isLoadingThirdStepData", false)

    case STEP_TWO_WATCHER:
      return state
    // .set('secondStepData', {})
    // .set('isLoadingSecondStepData', true)
    case STEP_TWO_SUCCESS:
      return state
        .set("secondStepData", action.payload)
        .set("isLoadingSecondStepData", false)
    case STEP_TWO_FAILED:
      return state
        .set("secondStepData", {})
        .set("isLoadingSecondStepData", false)

    case STEP_ONE_WATCHER:
      return (
        state
          // .set('firstStepData', {})
          .set("isLoadingFirstStepData", true)
      )
    case STEP_ONE_SUCCESS:
      return state
        .set("firstStepData", action.payload)
        .set("nameMeasurement", action.payload.name)
        .set("isLoadingFirstStepData", false)
    case STEP_ONE_FAILED:
      return (
        state
          // .set('firstStepData', {})
          .set("isLoadingFirstStepData", false)
      )
    case STEP_MAIL_WATCHER:
      return state.set("mailStepData", {}).set("isLoadingMailStepData", true)
    case STEP_MAIL_SUCCESS:
      return state
        .set("mailStepData", action.payload)
        .set("isLoadingMailStepData", false)
    case STEP_MAIL_FAILED:
      return state.set("mailStepData", {}).set("isLoadingMailStepData", false)
    case STEP_RECIPIENTS_WATCHER:
      return state
        .set("recipientsStepData", {})
        .set("isLoadingRecipientsStepData", true)
    case STEP_RECIPIENTS_SUCCESS:
      return state
        .set("recipientsStepData", action.payload)
        .set("isLoadingRecipientsStepData", false)
    case STEP_RECIPIENTS_FAILED:
      return state
        .set("recipientsStepData", {})
        .set("isLoadingRecipientsStepData", false)
    case STEP_DATACHECK_WATCHER:
      return state
        .set("dataCheckStepData", [])
        .set("isLoadingDataCheckStepData", true)
    case STEP_DATACHECK_SUCCESS:
      return state
        .set("dataCheckStepData", action.payload)
        .set("isLoadingDataCheckStepData", false)
    case STEP_DATACHECK_FAILED:
      return state
        .set("dataCheckStepData", [])
        .set("isLoadingDataCheckStepData", false)
    case STEP_PREVIEW_WATCHER:
      return state
        .set("previewStepData", {})
        .set("isLoadingPreviewStepData", true)
    case STEP_PREVIEW_SUCCESS:
      return state
        .set("previewStepData", action.payload)
        .set("isLoadingPreviewStepData", false)
    case STEP_PREVIEW_FAILED:
      return state
        .set("previewStepData", {})
        .set("isLoadingPreviewStepData", false)
    case STEP_SCHEDULE_WATCHER:
      return state
        .set("scheduleStepData", {})
        .set("isLoadingScheduleStepData", true)
    case STEP_SCHEDULE_SUCCESS:
      return state
        .set("scheduleStepData", action.payload)
        .set("isLoadingScheduleStepData", false)
    case STEP_SCHEDULE_FAILED:
      return state
        .set("scheduleStepData", {})
        .set("isLoadingScheduleStepData", false)
    case STEP_COMPLETE_WATCHER:
      return state
        .set("completeStepData", {})
        .set("isLoadingCompleteStepData", true)
    case STEP_COMPLETE_SUCCESS:
      return state
        .set("completeStepData", action.payload)
        .set("isLoadingCompleteStepData", false)
    case STEP_COMPLETE_FAILED:
      return state
        .set("completeStepData", {})
        .set("isLoadingCompleteStepData", false)
    case FORCE_SAVE_WATCHER:
      return state.set("isLoadingForceSaveData", true).set("forceSaveData", {})
    case FORCE_SAVE_SUCCESS:
      return state
        .set("isLoadingForceSaveData", false)
        .set("forceSaveData", action.payload)
    case FORCE_SAVE_FAILED:
      return state.set("isLoadingForceSaveData", false).set("forceSaveData", {})
    case GET_EMPLOYEES_BY_SEGMENTS_WATCHER:
      return state
        .set("isLoadingRecipientsSegments", true)
        .set("recipientsSegments", [])
    case GET_EMPLOYEES_BY_SEGMENTS_SUCCESS:
      return state
        .set("isLoadingRecipientsSegments", false)
        .set("recipientsSegments", action.payload)
    case GET_EMPLOYEES_BY_SEGMENTS_FAILED:
      return state
        .set("isLoadingRecipientsSegments", false)
        .set("recipientsSegments", [])
    case POST_IMAGE_EMAIL_WATCHER:
      return (
        state
          // .set('imageUrl', '')
          .set("isLoadingImageUrl", true)
      )
    case POST_IMAGE_EMAIL_SUCCESS:
      return state
        .set("imageUrl", action.payload)
        .set("isLoadingImageUrl", false)
    case POST_IMAGE_EMAIL_FAILED:
      return state.set("isLoadingImageUrl", false)

    case POST_LOGO_EMAIL_WATCHER:
      return state.set("logoUrl", "").set("isLoadingLogoUrl", true)
    case POST_LOGO_EMAIL_SUCCESS:
      return state.set("logoUrl", action.payload).set("isLoadingLogoUrl", false)
    case POST_LOGO_EMAIL_FAILED:
      return state.set("logoUrl", "").set("isLoadingLogoUrl", false)

    case GET_DESCENDANTS_WATCHER:
      return state.set("descendents", []).set("isLoadingDescendents", true)
    case GET_DESCENDANTS_SUCCESS:
      return state
        .set("descendents", action.payload)
        .set("isLoadingDescendents", false)
    case GET_DESCENDANTS_FAILED:
      return state.set("descendents", []).set("isLoadingDescendents", false)

    case GET_DIVISIONS_WATCHER:
      return state.set("isLoadingDescendents", true)
    // .set('divisions', {})
    // .set('isLoadingDivisions', true)
    case GET_DIVISIONS_SUCCESS:
      return state
        .set("divisions", action.payload)
        .set("isLoadingDivisions", false)
        .set("isLoadingDescendents", false)
    case GET_DIVISIONS_FAILED:
      return state.set("divisions", {}).set("isLoadingDivisions", false)

    case GET_MEASURE_WATCHER:
      return state.set("isLoadingMeasure", true).set("measure", {})
    case GET_MEASURE_SUCCESS:
      return state.set("measure", action.payload).set("isLoadingMeasure", false)
    case GET_MEASURE_FAILED:
      return state.set("measure", {}).set("isLoadingMeasure", false)
    case UPDATE_MEASURE_WATCHER:
      return state.set("isLoadingUpdateMeasure", true)
    case UPDATE_MEASURE_SUCCESS:
      return state.set("isLoadingUpdateMeasure", false)
    case UPDATE_MEASURE_FAILED:
      return state.set("isLoadingUpdateMeasure", false)
    case GET_SEGMENTS_WATCHER:
      return state.set("isLoadingSegments", true).set("segments", [])
    case GET_SEGMENTS_SUCCESS:
      return state
        .set("segments", action.payload)
        .set("isLoadingSegments", false)
    case GET_SEGMENTS_FAILED:
      return state.set("segments", []).set("isLoadingSegments", false)
    case GET_SURVEY_TYPES_WATCHER:
      return state.set("isLoadingSurveyTypes", true).set("surveyTypes", [])
    case GET_SURVEY_TYPES_SUCCESS:
      return state
        .set("surveyTypes", action.payload)
        .set("isLoadingSurveyTypes", false)
    case GET_SURVEY_TYPES_FAILED:
      return state.set("surveyTypes", []).set("isLoadingSurveyTypes", false)
    case GET_SCOPE_TYPES_WATCHER:
      return state.set("isLoadingScopeTypes", true).set("scopeTypes", [])
    case GET_SCOPE_TYPES_SUCCESS:
      return state
        .set("scopeTypes", action.payload)
        .set("isLoadingScopeTypes", false)
    case GET_SCOPE_TYPES_FAILED:
      return state.set("scopeTypes", []).set("isLoadingScopeTypes", false)
    case GET_ORGANIZATION_SURVEYS_WATCHER:
      return state
        .set("isLoadingOrganizationSurveys", true)
        .set("organizationSurveys", [])
    case GET_ORGANIZATION_SURVEYS_SUCCESS:
      return state
        .set("organizationSurveys", action.payload)
        .set("isLoadingOrganizationSurveys", false)
    case GET_ORGANIZATION_SURVEYS_FAILED:
      return state
        .set("organizationSurveys", [])
        .set("isLoadingOrganizationSurveys", false)
    case GET_SEGMENTS_SURVEYS_WATCHER:
      return state
        .set("isLoadingSegmentsSurveys", true)
        .set("segmentsSurveys", [])
    case GET_SEGMENTS_SURVEYS_SUCCESS:
      return state
        .set("segmentsSurveys", action.payload)
        .set("isLoadingSegmentsSurveys", false)
    case GET_SEGMENTS_SURVEYS_FAILED:
      return state
        .set("segmentsSurveys", [])
        .set("isLoadingSegmentsSurveys", false)
    default:
      return state
  }
}

export default measurementCreateReducer
